module.exports = __webpack_public_path__ + "static/media/1004113.03629672.png";